import { render, staticRenderFns } from "./aspect-ratio-video.vue?vue&type=template&id=12954b6d&"
import script from "./aspect-ratio-video.vue?vue&type=script&lang=js&"
export * from "./aspect-ratio-video.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports